//#region src/menu_price_style.ts
var MenuPriceStyle = /* @__PURE__ */ function(MenuPriceStyle) {
	MenuPriceStyle[MenuPriceStyle["Default"] = 0] = "Default";
	MenuPriceStyle[MenuPriceStyle["OneDigit"] = 1] = "OneDigit";
	MenuPriceStyle[MenuPriceStyle["TwoDigits"] = 2] = "TwoDigits";
	return MenuPriceStyle;
}(MenuPriceStyle || {});
//#endregion
export { MenuPriceStyle };

//# sourceMappingURL=menu_price_style.js.map